/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupplierRetailer
 */
export interface SupplierRetailer {
    /**
     * Required for removal; optional for addition
     * @type {string}
     * @memberof SupplierRetailer
     */
    id: string;
    /**
     * Required for addition; an identifier for the retailer
     * @type {string}
     * @memberof SupplierRetailer
     */
    customerCode?: string;
}

/**
 * Check if a given object implements the SupplierRetailer interface.
 */
// @ts-ignore
export function instanceOfSupplierRetailer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

// @ts-ignore
export function SupplierRetailerFromJSON(json: any): SupplierRetailer {
    return SupplierRetailerFromJSONTyped(json, false);
}

// @ts-ignore
export function SupplierRetailerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierRetailer {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'customerCode': !exists(json, 'customer_code') ? undefined : json['customer_code'],
    };
}

// @ts-ignore
export function SupplierRetailerToJSON(value?: SupplierRetailer | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'customer_code': value.customerCode,
    };
}

